<form [formGroup]="form.formGroup">
    <div class="flex flex-col space-y-2">
        <app-general-epp
            [formControlName]="form.formControlNames.generalEpp"
            [currentString]="currentString"
            [userUnits]="userUnits"
            [loadCaseIndex]="loadCaseIndex"
            [hideDeterioratedMudOption]="true"
        ></app-general-epp>

        <div>
            <p-checkbox
                size="small"
                binary="true"
                [formControlName]="form.formControlNames.allowFractureAtShoe"
                inputId="allowFractureAtShoe"
                (onChange)="allowFracAtShoeChange()"
            ></p-checkbox>
            <label class="ml-2" for="allowFractureAtShoe">Allow Fracture at Shoe</label>
        </div>

        <p-fieldset legend="Fracture Pressure">
            <div [class.pointer-events-none]="!fracAtShoe"
              [class.opacity-50]="!fracAtShoe" class="flex flex-col space-y-2">
                <app-uom-input
                    label="Fracture Depth"
                    [unitLabel]="userUnits.longLengths + ' MD'"
                    [formControlName]="form.formControlNames.fractureDepth"
                    [control]="'fractureDepth'"
                    [default]="fractureDepthDefault"
                    [validators]="validators.fractureDepth"
                    title="Allowed range: {{ fracDepthsRange?.min }} - {{ fracDepthsRange?.max }} {{ userUnits.longLengths }}"
                    (focusout)="fractureDepthChange(true)"
                />

                @if (defaultFracGradient) {
                    <app-uom-input
                        label="Fracture Gradient"
                        [unitLabel]="densityLabel"
                        [formControlName]="form.formControlNames.fractureGradient"
                        [control]="'fractureGradient'"
                        [default]="defaultFracGradient"
                        [validators]="validators.fractureGradient"
                        title="Allowed range: {{ fractureGradientValidation.min }} - {{ fractureGradientValidation.max }} {{ densityLabel }}"
                        (focusout)="fractureGradientChange()"
                    />
                }

                <app-uom-input
                    label="Margin of Error"
                    [unitLabel]="densityLabel"
                    [formControlName]="form.formControlNames.fractureMarginOfError"
                    [control]="'fractureMarginOfError'"
                    [default]="'0'"
                    [validators]="validators.fractureMarginOfError"
                    title="Allowed range: {{ marginOfErrorValidation.min }} - {{ marginOfErrorValidation.max }} {{ densityLabel }}"
                />
            </div>
        </p-fieldset>

        <p class="text-sm">
            Top Of Cement: &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            {{ currentString?.topOfCementMd.toFixed(2) }} {{ userUnits.longLengths }}
        </p>

        <app-uom-input
            label="Hydraulic Interface Depth"
            [unitLabel]="lengthUnitLabel"
            [formControlName]="form.formControlNames.hydraulicInterfaceDepth"
            [control]="'hydraulicInterfaceDepth'"
            [default]="hydraulicInterfaceDepthDefault"
            [validators]="validators.hydraulicInterfaceDepth"
            title="Allowed range: {{ hydraulicInterfaceDepthRange.min }} - {{ hydraulicInterfaceDepthRange.max }} {{ lengthUnitLabel }}"
        />
    </div>
</form>